import axios from "axios";
import { api } from "./api_route";

export const getCommAuditTrails = async (data) => {
  try {
    const response = await axios.post(`${api}/commAuditTrails/get`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
